import { render, staticRenderFns } from "./msgtypeWeapp.vue?vue&type=template&id=2bdc578e&scoped=true&"
import script from "./msgtypeWeapp.vue?vue&type=script&lang=js&"
export * from "./msgtypeWeapp.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeWeapp.vue?vue&type=style&index=0&id=2bdc578e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc578e",
  null
  
)

export default component.exports